import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {Order, OrderState} from '../../models';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {extractIri} from '../../../shared/utilities/objects.utility';
import {DataRecoveryPriorityMode} from '../../../master-data/models';
import {DataRecoveryPriorityModesSelectors} from '../../../master-data/store/selectors';
import {DataRecoveryPriorityModesActions} from '../../../master-data/store';
import {distinctUntilChanged, takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-order-priority-mode-select',
  styleUrls: ['./order-priority-mode-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OrderPriorityModeSelectComponent),
    multi: true
  }],
  template: `
    <div [formGroup]="form">

      <ng-select
        formControlName="selectedElement"
        [items]="items$|async"
        bindLabel="name"
        [searchable]="true"
        [loading]="isLoading$| async"
        bindValue="@id"
        [clearable]="true"
        [searchFn]="findItem"
        [placeholder]="'orders.order_priority_mode_select.placeholder' | translate"
        (change)="setSelectedItem($event)">

        <ng-template ng-label-tmp let-item="item">
          {{item.name}}

        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.name}}
        </ng-template>
      </ng-select>
    </div>
  `
})
export class OrderPriorityModeSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  form: FormGroup;
  @Output() updateSelectedObject: EventEmitter<DataRecoveryPriorityMode> = new EventEmitter<DataRecoveryPriorityMode>();

  items$: Observable<Array<DataRecoveryPriorityMode>>;
  isLoading$: Observable<boolean>;
  selectedItem: DataRecoveryPriorityMode;
  onDestroy$: Subject<any> = new Subject<any>();

  orders: Order[];
  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor(
    private store$: Store<ApplicationState>,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      selectedElement: this.fb.control(null),
    });

    this.form.get('selectedElement').valueChanges.pipe(takeUntil(this.onDestroy$), distinctUntilChanged()).subscribe(value => {
      this.onChange(value);
    });

    this.items$ = this.store$.select(DataRecoveryPriorityModesSelectors.sList);
    this.isLoading$ = this.store$.select(DataRecoveryPriorityModesSelectors.isLoading);
    loadIfNotLoaded(this.store$, DataRecoveryPriorityModesSelectors.isLoaded, DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModes());
  }

  setSelectedItem(element: OrderState): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: OrderState): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.name.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;

  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.get('selectedElement').disable();
    } else {
      this.form.get('selectedElement').enable();
    }
  }

  writeValue(value: any): void {
    this.form.get('selectedElement').setValue(extractIri(value));
  }
}
